import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Box, Button, Dialog, Stack, Typography } from "@mui/material";
import { enrollableNmlBoards } from "../../utils/nmlSuzhouCatalog";
import { enrollNmlSuzhouProduct } from "../../api/NmlSuzhou/nmlSuzhouApi";

export default function NmlEnrollDialog({
  open,
  product,
  permissions,
  onClose,
  onEnrolled,
}) {
  const { t } = useTranslation();
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const handlePick = async (boardKey) => {
    if (!product?.id) return;
    setSaving(true);
    setError("");
    try {
      await enrollNmlSuzhouProduct(product.id, boardKey);
      onEnrolled?.(boardKey, product);
      onClose?.();
    } catch (err) {
      setError(err.response?.data?.error || err.message || t("NmlSuzhou.enrollError"));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onClose={saving ? undefined : onClose}>
      <Box sx={{ p: 3, minWidth: { xs: 280, sm: 420 } }}>
        <Typography variant="h6" sx={{ mb: 1.5 }}>
          {t("NmlSuzhou.enrollTitle")}
        </Typography>
        <Typography variant="body1" sx={{ mb: 2 }}>
          {t("NmlSuzhou.enrollBody", { name: product?.nombre || "" })}
        </Typography>
        {error ? (
          <Typography color="error" variant="body2" sx={{ mb: 2 }}>
            {error}
          </Typography>
        ) : null}
        <Stack spacing={1}>
          {enrollableNmlBoards(permissions).map((board) => (
            <Button
              key={board.key}
              variant="contained"
              disabled={saving}
              onClick={() => handlePick(board.key)}
            >
              {t(`NmlSuzhou.boards.${board.key}`)}
            </Button>
          ))}
          <Button variant="outlined" disabled={saving} onClick={onClose}>
            {t("NmlSuzhou.enrollSkip")}
          </Button>
        </Stack>
      </Box>
    </Dialog>
  );
}
